import moment from "moment";


const getTimeDifferent = (utcTime) => {

    const localTime = moment.utc(utcTime, "YYYY-MM-DDTHH:mm:ss.SSSSSSZ").local();
    
    const minutesAgo = moment().diff(localTime, 'minutes');
    const hoursAgo = moment().diff(localTime, 'hours');
    const daysAgo = moment().diff(localTime, 'days');
    const monthsAgo = moment().diff(localTime, 'months');

    if (minutesAgo < 60) {
        return `${minutesAgo}m`
    } else if (hoursAgo < 24) {
        return `${hoursAgo}h`
    } else if (daysAgo <= 21) {
        return `${daysAgo}d`
    }
    else if (monthsAgo >= 1) {
        return `${monthsAgo}mo`
    }
    else {
        return "0m"
    }
}

export default getTimeDifferent;